import React from 'react';
import { useStacklineTheme, StacklineColor, hexToRgba } from '@stackline/ui';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

interface StatusTagProps {
  children: string;
  color: StacklineColor;
  backgroundColor: StacklineColor | string;
  opacity?: number;
}

/**
 * A statusTag for use in the table status.
 * This pill will be placed on the review cards sentiment status
 */
const StatusTag = ({ children, color, backgroundColor, opacity = 0.1 }: StatusTagProps) => {
  const theme = useStacklineTheme();

  return (
    <div
      style={{
        backgroundColor: hexToRgba(theme.colors[backgroundColor], opacity),
        borderRadius: '4px',
        padding: '4px 8px',
        display: 'inline-flex',
        height: '24px',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Text variant="subtitle3" color={color}>
        {children}
      </Text>
    </div>
  );
};

export default StatusTag;
